@if (formState$ | async; as formState) {
  @if (!formState.success && !formState.error) {
    <form [formGroup]="callbackForm" class="callback-form" action="submit">
      <h3 class="callback-form__title text-h6-s text-md-h3-s">Заявка</h3>
      <sd-input class="callback-form__phone-input" label="номер телефона">
        <input type="tel" sdPhoneMaskFix formControlName="phone" sdPhoneAuthorizedUser />
      </sd-input>
      <div>
        <button
          class="callback-form__submit-btn"
          sdButton
          [disabled]="callbackForm.disabled || !callbackForm.valid"
          theme="primary"
          [fullWidth]="isMobile$ | async"
          size="l"
          (click)="submitForm()"
        >
          Отправить заявку
        </button>
      </div>
      <div class="callback-form__agreement">
        <sd-personal-data-agree-text-callback></sd-personal-data-agree-text-callback>
      </div>
    </form>
  }

  @if (formState.success) {
    <sd-success-msg></sd-success-msg>
  }

  @if (formState.error) {
    <sd-error-msg></sd-error-msg>
  }
}
